import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap, SoloLoading } from '../../components';
import PsychologyPromptForm from './PsychologyPromptForm';
import { useParams } from 'react-router';
import { Api } from '../../api';

export default function EditPsychologyPromptScreen() {
  const { weekNumber, weekId, id } = useParams();

  const api = Api.PsychologyPrompt.useReadItemAsAdmin(id ?? '');

  if (!api.data) return <SoloLoading />;

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Edit Psychology Prompt"
          items={[
            {
              name: `Program Week ${weekNumber}`,
              url: `/program/${weekNumber}/${weekId}/psychology-prompts`,
            },
          ]}
        />
        <PsychologyPromptForm existing={api.data} />
      </Stack>
    </ScreenWrap>
  );
}
